import { FC } from "react"
import CodeMirror from "@uiw/react-codemirror"
import { json } from "@codemirror/lang-json"

interface Props {
  value: string
  onChange: (value: string) => void
  dataType: "lead" | "subscription" | "pending_subscription" | "lead_score"
}

const TemplateCodeEditor: FC<Props> = ({ value, onChange, dataType }) => {
  // Ensure value is always a string
  const templateValue =
    typeof value === "string" ? value : JSON.stringify(value, null, 2)

  return (
    <div className="relative border border-gray-300 rounded-md overflow-hidden">
      <CodeMirror
        value={templateValue}
        height="500px"
        extensions={[json()]}
        onChange={value => onChange(value)}
        theme="light"
        basicSetup={{
          lineNumbers: true,
          highlightActiveLineGutter: true,
          highlightSpecialChars: true,
          foldGutter: true,
          drawSelection: true,
          dropCursor: true,
          allowMultipleSelections: true,
          indentOnInput: true,
          syntaxHighlighting: true,
          bracketMatching: true,
          closeBrackets: true,
          autocompletion: true,
          rectangularSelection: true,
          crosshairCursor: true,
          highlightActiveLine: true,
          highlightSelectionMatches: true,
          closeBracketsKeymap: true,
          searchKeymap: true,
          foldKeymap: true,
          completionKeymap: true,
          lintKeymap: true
        }}
      />
    </div>
  )
}

export default TemplateCodeEditor
